"use client";

import React, { useCallback } from "react";
import { useRouter } from "next/navigation";
import { CompanyDetailsTab as ReusableCompanyDetailsTab } from "@/components/shared/detail-tabs/CompanyDetailsTab";
import { CompanyContacts } from "@/features/companies/components/CompanyContacts";
import type { TabContentProps } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { Ticket } from "@/lib/types/database";

/**
 * Ticket Company Display Tab Component
 *
 * Wraps the reusable CompanyDetailsTab with ticket-specific context and company contacts list.
 * CompanyDetailsTab and CompanyContacts will automatically use company_id from EntityContext.
 */
export const TicketCompanyDisplay = React.memo(({ item }: TabContentProps<Ticket>) => {
  const router = useRouter();

  const handleViewFullCompany = useCallback(
    (companyId: string) => {
      router.push(`/companies/${companyId}`);
    },
    [router]
  );

  return (
    <div className="w-full space-y-4">
      <ReusableCompanyDetailsTab
        onViewFullCompany={handleViewFullCompany}
      />

      {item.company_id && <CompanyContacts />}
    </div>
  );
});

TicketCompanyDisplay.displayName = "TicketCompanyDisplay";
